var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 12.3234C5.3335 11.5059 5.3335 11.0971 5.48574 10.7296C5.63798 10.362 5.92701 10.073 6.50507 9.49493L8.16192 7.83808C8.73998 7.26002 9.02901 6.97099 9.39656 6.81874C9.7641 6.6665 10.1728 6.6665 10.9904 6.6665H21.01C21.8275 6.6665 22.2362 6.6665 22.6038 6.81874C22.9713 6.97099 23.2603 7.26002 23.8384 7.83808L25.4953 9.49493C26.0733 10.073 26.3623 10.362 26.5146 10.7296C26.6668 11.0971 26.6668 11.5059 26.6668 12.3234V22.6665C26.6668 24.5521 26.6668 25.4949 26.081 26.0807C25.4953 26.6665 24.5524 26.6665 22.6668 26.6665H9.3335C7.44788 26.6665 6.50507 26.6665 5.91928 26.0807C5.3335 25.4949 5.3335 24.5521 5.3335 22.6665V12.3234Z",
    stroke: "#7161BA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 13.3335H26.6668",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7774 12L12.2218 12C11.9076 12 11.7504 12 11.6528 12.0976C11.5552 12.1953 11.5552 12.3524 11.5552 12.6667L11.5552 18.2222C11.5552 19.242 11.5552 19.7518 11.6871 20.0259C11.9814 20.6376 12.6885 20.9305 13.3292 20.7061C13.6163 20.6056 13.9768 20.245 14.6979 19.524C15.0318 19.19 15.1988 19.023 15.3764 18.9291C15.7663 18.723 16.2329 18.723 16.6229 18.9291C16.8004 19.023 16.9674 19.19 17.3014 19.524C18.0224 20.245 18.383 20.6056 18.67 20.7061C19.3107 20.9305 20.0178 20.6376 20.3122 20.0259C20.4441 19.7518 20.4441 19.242 20.4441 18.2222V12.6667C20.4441 12.3524 20.4441 12.1953 20.3464 12.0976C20.2488 12 20.0917 12 19.7774 12Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.453a6d5dcf5645aead9e084a1e583a87.svg";
export { ForwardRef as ReactComponent };